import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useCategory } from '../api/hooks/catalog';
import { useCustomerSelectedFinanceModels } from '../api/hooks/companies';
import { useFinanceModels, usePeripheralFinanceModels } from '../api/hooks/financemodels';
import { RoleType } from '../authentication/hooks/user';
import { useCatalogueService } from '../catalogue/useCatalogueService';

export const useSelectedCustomerFinanceModelForCategoryAndManufacturer = (
  categoryId: string,
  manufacturerId: string
) => {
  const { partnerId, companyId } = useParams();
  const [category] = useCategory(categoryId);

  if (!(partnerId && companyId)) throw new Error('Missing params');
  if (!category) throw new Error(`Missing category with id ${categoryId}`);

  const [configuration] = useCatalogueService(state => [state.configuration]);

  const [selectedModels] = useCustomerSelectedFinanceModels(companyId, partnerId);
  const financeModels = useFinanceModels();
  const peripheralModels = usePeripheralFinanceModels();

  return useMemo(() => {
    if (configuration.for !== RoleType.Company) return null;

    if (category.isMainDevice) {
      const relevantModels = financeModels.filter(
        model => model.manufacturerId === manufacturerId && model.categoryId === categoryId
      );

      return relevantModels.find(m => selectedModels.financeModelIds.includes(m.id)) || null;
    } else {
      const selectedModel = peripheralModels.find(model => model.id === selectedModels.peripheralFinanceModelId);

      return selectedModel ?? null;
    }
  }, [financeModels, peripheralModels, categoryId, manufacturerId]);
};
